import { getTMinus1, toISO8601 } from '@fortem-monorepo/js-utilities'
import { DialogProps } from '@fortem-monorepo/react-ui'
import { SubmitButton } from '@fortem-monorepo/react-ui'
import { Button } from '@fortem-monorepo/react-ui'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@fortem-monorepo/react-ui'

import { RunFixedIncomeForm } from '@/components/forms/RunFixedIncomeForm/RunFixedIncomeForm'
import { RunFixedIncomeFormFields } from '@/components/forms/RunFixedIncomeForm/RunFixedIncomeFormFields'

export interface RunFixedIncomeModalProps extends DialogProps {}

export const RunFixedIncomeModal: React.FC<RunFixedIncomeModalProps> = ({ ...props }) => {
  return (
    <Dialog {...props}>
      <DialogContent>
        <RunFixedIncomeForm defaultValues={{ value_date: toISO8601(getTMinus1()) }}>
          {({ formState: { isValid, isSubmitting } }) => {
            return (
              <>
                <DialogHeader>
                  <DialogTitle>Run Fixed Income</DialogTitle>
                </DialogHeader>
                <div className="py-6">
                  <RunFixedIncomeFormFields />
                </div>
                <DialogFooter>
                  <Button
                    size="sm"
                    variant={'destructive'}
                    type="button"
                    onClick={() => props.onOpenChange?.(false)}
                  >
                    Cancel
                  </Button>
                  <SubmitButton
                    disabled={!isValid || isSubmitting}
                    loading={isSubmitting}
                    size="sm"
                  >
                    Submit
                  </SubmitButton>
                </DialogFooter>
              </>
            )
          }}
        </RunFixedIncomeForm>
      </DialogContent>
    </Dialog>
  )
}
